<template style="height: 100%;">
  <div style="height: 850px;display: flex;width: 100%;">
    <div v-if="excess === '1'"></div>
    <div v-else style="width: 100%;">
      <div v-if="isShowTadSim" style="height: calc(100vh - 120px);">
        <div style="height: 100%; display: grid; justify-content: center; align-content: center; font-size: 30px;">
          本阶段仅供联合汽车电子有限公司内部员工和受邀人员使用
        </div>
      </div>
      <div  v-else class="loginDiv">
        <div style="padding: 100px;">
          <el-form
            ref="registerFormRef"
            class="content"
            :model="form"
            label-width="80px"
            label-position="left"
          >
            <el-steps class="steps" :active= stepActive align-center finish-status="success">
                <el-step title="进行个人认证"></el-step>
                <el-step title="认证结果"></el-step>
            </el-steps>
            <div class="carousel">
                <el-carousel ref="carousel" initial-index="0" height="320px" :autoplay="false" indicator-position="none" arrow="never" :loop="false">
                    <el-carousel-item :key="1">
                      <div>
                        <el-form :model="from" status-icon :rules="rules" ref="from" label-width="100px" :label-position="right" class="from">
                          <el-form-item label="真实姓名" prop="userName">
                            <el-input type="text" v-model.trim="from.userName" autocomplete="off" placeholder="请输入真实姓名">
                            </el-input>
                          </el-form-item>
                          <el-form-item label="身份证号码" prop="idCard">
                            <el-input v-model.trim="from.idCard" autocomplete="off" placeholder="身份证号码">
                            </el-input>
                          </el-form-item>
                        </el-form>
                        <div style="width: 100%;text-align: center;">
                          <el-button class="firstStepButton" @click="firstStepClick()">下一步</el-button>
                        </div>
                      </div>
                    </el-carousel-item>
                    <el-carousel-item :key="2">
                      <div style="text-align: center;paddingTop: 42px">
                        <img align="middle" style="width: 180px; height: 180px" src="../../assets/img/usp/loginWasSuccessful.png" />
                      </div>
                      <div class="welcomeTittle">
                        认证成功
                      </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <el-dialog
              title="扫码认证"
              :visible.sync="visible"
              :modal-append-to-body="false"
              width="50%"
              :before-close="handleClose"
              center>
              <el-form :model="catalogueProperties" >
                <el-row>
                  <el-col style="text-align: center">
                    <el-image :src="detectAuth.imageUrl" style="width: 240px;height: 240px">
                    </el-image>
                </el-col>
                </el-row>
                <el-row style="text-align: center; height: 20px;font-size: 14px;font-weight: 400; color: #808080;line-height: 20px;margin: 20px auto 12px auto;">
                  请使用【微信】扫码验证
                </el-row>
              </el-form>
            </el-dialog>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isShowTadSim } from '@/api/modules/professionalLevel'
import { getDetectAuth, getResults } from '@/api/modules/facialNucleus'
import { getUserInfo } from '@/api/modules/iam'
export default {
  name: 'FacialNucleus',
  components: {
  },
  data() {
    var validateUserName = (rule, value, callback) => {
      const res = /^(?:[\u4e00-\u9fa5·]{2,16})$/
      if (!value) {
        return callback(new Error('真实姓名不能为空'))
      }
      else {
        if (!res.test(value)) {
          callback(new Error(' 请输入真实姓名'))
        }
        callback()
      }
    }
    var validateIdCard = (rule, value, callback) => {
      // 身份证号, 支持1/2代(15位/18位数字)
      const res = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
      if (!value) {
        return callback(new Error('身份证号码不能为空'))
      }
      else {
        if (!res.test(value)) {
          callback(new Error(' 请输入真实的身份证号码'))
        }
        callback()
      }
    }
    return {
      stepActive: '1',
      activeIndex: '1',
      radio: '1',
      from: {
        userName: '',
        idCard: ''
      },
      canSubmit: false,
      showCount: true,
      rules: {
        userName: [
          { validator: validateUserName, required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        idCard: [
          { validator: validateIdCard, required: true, message: '请输入身份证号码', trigger: 'blur' }
        ]
      },
      visible: false,
      imgSrc: '',
      detectAuth: {
        imageUrl: '',
        bizToken: '',
        requestId: ''
      },
      number: 7200,
      results: null,
      userResults: null,
      isShowTadSim: false,
      excess: '1'
    }
  },
  computed: {
  },
  watch: {
  },
  destroyed() {
    clearInterval(this.results)
    clearInterval(this.userResults)
  },
  async created() {
    const that = this
    this.userResults = await setInterval(() => {
      that.iShowTadSim()
    }, 1000)
  },
  methods: {
    async iShowTadSim() {
      const that = this
      const userInfo = JSON.parse(localStorage.getItem('usersCurrentInfo'))
      if (userInfo.source === '1') {
        if (userInfo.authentication !== '1') {
          const res = await isShowTadSim({ phone: userInfo.phone })
          if (res.code === 0) {
            if (res.data) {
              this.excess = '2'
              this.isShowTadSim = true
            }
            else {
              this.excess = '2'
              this.isShowTadSim = false
              await getResults({ bizToken: 'E4C766F3-FD17-4DCB-A0DA-923C57610BD5' })
            }
          }
        }
        else {
          that.userInfo()
          this.$router.push('/article/Professional')
        }
      }
      else {
        that.userInfo()
        this.$router.push('/article/Professional')
      }
    },
    catalogueUpdate() {
      this.stepActive = '2'
      this.$refs.carousel.next()
    },
    firstStepClick() {
      // if (this.results) return
      this.$refs['from'].validate((valid) => {
        if (valid) {
          this.getDetectAuth()
        }
      })
    },
    async getDetectAuth() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: '#F6F8FC'
      })
      const res = await getDetectAuth({ userName: this.from.userName, idCard: this.from.idCard })
      console.log(res)
      if (res.code === 0) {
        this.detectAuth = res.data
        this.visible = true
        loading.close()
        this.polling()
      }
      else {
        loading.close()
      }
    },
    handleClose(done) {
      // if (this.results) {
      //   this.$message({
      //     message: '认证结果确认中，请稍后。期间请勿操作！',
      //     type: 'error'
      //   })
      //   return null
      // }
      // else {
      this.visible = false
      // }
    },
    async getResults() {
      const that = this
      const res = await getResults({ bizToken: that.detectAuth.bizToken, requestId: that.detectAuth.requestId })
      if (res.code === 0) {
        clearInterval(this.results)
        that.results = null
        that.visible = false
        that.catalogueUpdate()
        that.userInfo()
      }
    },
    polling() {
      const that = this
      this.results = setInterval(() => {
        that.getResults()
      }, 1000)
    },
    async userInfo() {
      const res = await getUserInfo()
      if (res.code === 0) {
        localStorage.setItem('usersCurrentInfo', JSON.stringify(res.data))
      }
    }
  }
}
</script>

<style lang="less" scoped>
  body{
    width:100%;
    height:100%;
  }
    ::-webkit-scrollbar{
      display:none;
    }
    .flex{
      display: flex
    }
    .flexLeft{
      width: calc(100vw);
      position: relative;
    }
    .flexRight{
      background-color: #4d78ff;
      width: calc(100vw * 0.29);
      height: 100vh;
    }
    .loginDiv{
      // align-self: center;
      // background: #FFFFFF;
      // box-shadow: 0px 17px 28px 4px rgba(0,127,243,0.09);
      // border-radius: 4px;
      // width: 1000px;
      // margin: auto;
      background: #FFFFFF;
      box-shadow: 0px 0px 0px 0px rgb(0 127 243 / 9%);
      border-radius: 4px;
      width: 100%;
    }
    .title{
        text-align: center;
        font-size: 24px;
        color: #4d78ff;
        font-family:"微软雅黑";
        font-weight: 400;
    }
    .directions{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 25px;
    }
    .steps{
      margin-top: 32px;
      margin-bottom: 60px;
    }
    ::v-deep .el-step__head.is-success {
        color: #4d78ff;
        border-color: #4d78ff;
    }
    ::v-deep .el-step__title.is-success {
        font-weight: bold;
        color: #4d78ff;
    }
    ::v-deep .el-step__description.is-success {
        color: #4d78ff;
    }
    ::v-deep .el-step__head.is-success .el-step__icon{
        color: #ffffff;
        background: #4d78ff;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
  }
  .transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
  .carouselItem{
    width: 500px;
    padding-left: 250px;
    text-align: center;
  }
  .carousel{
    width: 600px;
    margin: 0 auto;
  }
  .firstStepButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .secondStepButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .registerButton{
    margin-top: 45px;
    width: 480px;
    height: 60px;
    background: #4d78ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
  }
  .appendText{
    font-size: 14px;
    font-weight: 400;
    color: #2F374B;
  }
  .normalButton{
    background: #DBDBDB !important;
    border: 1px solid #DBDBDB !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .usableButton{
    background: #003A6F !important;
    border: 1px solid #003A6F !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .radioList{
    height: 210px;
  }
  .radioListView{
    height: 210px;
  }
  .radioTitle{
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    color: #838383;
  }
  .radioListCellView{
    margin-top: 20px;
    height: 190px;
    overflow-y: auto;
  }
  .radioCell{
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #838383;
  }
  ::v-deep .el-input__inner {
    height:36px
  }
  ::v-deep .el-form-item__label{
    width: 120px !important;
  }
  ::v-deep .el-form-item__content{
    margin-left: 120px !important;
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #4d78ff !important;
    background: #4d78ff !important;
  }
  ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #4d78ff !important;
  }
  .el-icon-share {
    background: url('../../assets/img/usp/enterprise.png') center center no-repeat;
    background-size: 24px;
  }
  .el-icon-share:before {
    content: "11";
    visibility: hidden;
  }
  .el-icon-s-data {
    background: url('../../assets/img/usp/college.png') center center no-repeat;
    background-size: 24px;
  }
  .el-icon-s-data:before {
    content: "11";
    visibility: hidden;
  }
  .countdown .getNumber{
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF !important;
      background: #4d78ff !important;
  }
  ::v-deep .el-step__icon{
    width: 38px;
    height: 38px;
  }
  ::v-deep .el-step.is-horizontal .el-step__line{
    top: 17px;
  }
  .welcomeTittle{
    height: 24px;
    font-size: 24px;
    font-weight: 400;
    color: #2F374B;
    text-align: center;
    padding-top: 20px;
  }
  .welcomeMessage{
    height: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 25px;
    text-align: center;
    padding-top: 20px;
  }
</style>
